module.exports = __webpack_public_path__ + "img/831.4d8bd0c8.gif";